module.exports={...require("./withContent"),...require("./withCookies"),...require("./withParams")};